// @ts-nocheck
import { useEffect, useState, useRef } from "react";
import { Response } from "../../../../types/response";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
} from "@mui/material";
import MDButton from "components/MDButton";
import {
  states,
  provinces,
  countries,
  getStatesProvinces,
  getStateProvinceLabel,
  getZipPostalLabel,
} from "../../../../utils/States";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import { get, post, request } from "requests";
import { useSubmissionStore } from "../../../../models/applications/SubmissionStore";
import IconButton from "@mui/material/IconButton";
import { useMerchantContext } from "./MerchantContext";
import { useStoreActions, useStoreState } from "easy-peasy";
import { Autocomplete } from "@mui/material";
import MDInput from "components/MDInput";
import { PersonAdd } from "@mui/icons-material";
import { InputAdornment } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { NumericFormat } from "react-number-format";
import { styled } from "@mui/material/styles";
import MDSelect from "components/MDSelect";
import MDSnackbar from "components/MDSnackbar";

const dataMerchColorMapping = {
  "Suspicious Activity": "#C22121",
  "Slow Pay": "#BD8D46",
  "Default Account": "#04756F",
  Other: "#25557a",
  "Covid-19 Hardship": "#EBC700",
  "Split Payer": "#F57336",
  "Stacking History": "#7F1367",
  Default: "#04756F",
};

type SnackBarDataType = {
  open: boolean;
  title: string;
  content: string;
  color: string;
};

const InitialInformation = ({ merchantData = [], dealApplicationId, fetchUsersRole }) => {
  const { triggerClearData, selectedCountry, setSelectedCountry } = useMerchantContext();
  const {
    userList,
    brokerParties = [],
    funderList,
    updateMerchantBusinessInfo,
    brokerId,
    merchantBusinessInfo,
    updateMerchantAndOwners,
    setDbaInformationData,
    setAffiliatedBusinessesData,
    setMerchantData,
    clearAllData,
    fetchMerchantData,
    fetchBrokerData,
    fetchFunderList,
    contractData,
    loadSalesRepsForCurrentBroker,
    updateSalesReps,
    salesRepOptions,
    assignedRepIds,
    setBrokerId,
    setBrokerName,
  } = useSubmissionStore();

  const contractTerms = useStoreState((state: any) => state.offerStore.contractTerms);
  const saveContractTerms = useStoreActions((actions: any) => actions.offerStore.saveContractTerms);
  const getContractTerms = useStoreActions((actions: any) => actions.offerStore.getContractTerms);

  const [snackBarData, setSnackBarData] = useState<SnackBarDataType>({
    open: false,
    title: "",
    content: "",
    color: "",
  });
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const [federalTaxId, setFederalTaxId] = useState("");
  const [newBusinessName, setNewBusinessName] = useState("");
  const [isAddingNewMerchant, setIsAddingNewMerchant] = useState(false);
  const [newMerchantId, setNewMerchantId] = useState<string | null>(null);
  const [dataMerch, setDataMerch] = useState([]);
  const [showDataMerchModal, setShowDataMerchModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [uniqueDataMerchCategory, setUniqueDataMerchCategory] = useState([]);
  const [dataMerchMessage, setDataMerchMessage] = useState("");
  const [validationError, setValidationError] = useState<any>(null);
  const [isAddingNewBroker, setIsAddingNewBroker] = useState<boolean>(false);
  const [isAddingNewFunder, setIsAddingNewFunder] = useState<boolean>(false);

  const listboxRef = useRef(null);

  // Methods to get and update country code
  const getCountryCode = (): string => {
    return selectedCountry || "";
  };

  const updateCountryCode = async (newCountryCode: string) => {
    setSelectedCountry(newCountryCode);

    // Update the data array to reflect the country change
    setData((prevData) =>
      prevData.map((item) => {
        if (item.label === "Country") {
          return { ...item, value: newCountryCode };
        }
        if (item.label === "State") {
          return { ...item, value: "" }; // Reset state when country changes
        }
        return item;
      })
    );

    // If there's merchant business info, update it on the backend
    if (merchantBusinessInfo?.merchantId && dealApplicationId) {
      try {
        const payload = {
          id: merchantBusinessInfo.merchantId,
          countryCode: newCountryCode,
        };

        // Call API to update merchant country
        const response = await post("updateMerchantCountry", payload);
        if (response.result) {
          console.log("Country code updated successfully:", newCountryCode);
          // Refresh merchant data if needed
          fetchMerchantData(merchantBusinessInfo.merchantId, false);
        }
      } catch (error) {
        console.error("Error updating country code:", error);
        // Revert the change if API call fails
        setSelectedCountry(selectedCountry);
        setData((prevData) =>
          prevData.map((item) => {
            if (item.label === "Country") {
              return { ...item, value: selectedCountry || "" };
            }
            return item;
          })
        );
      }
    }
  };

  const [data, setData] = useState([
    { label: "Business Name", value: null, isDropdown: true },
    { label: "Federal Tax ID", value: "", isDropdown: false },
    { label: "Country", value: "", isDropdown: true },
    { label: "State", value: "", isDropdown: true },
    {
      label: "Funder",
      value: contractTerms?.contractTerms?.funder?.id || null,
      isDropdown: true,
    },
    { label: "ISO/Broker", value: brokerId, isDropdown: true },
    { label: "Sales Representative", value: "", isDropdown: true },
    { label: "Amount Requested", value: "", isDropdown: false },
  ]);

  const merchantDropdownOptions = [
    { label: "Add New Merchant", value: "Add New Merchant" },
    ...merchantData.flatMap((merchant) => [
      {
        label: merchant.merchantName,
        value: merchant.merchantId,
        type: "merchant",
      },
      ...(merchant.federalTaxId
        ? [
            {
              label: merchant.federalTaxId,
              value: `taxid_${merchant.merchantId}`,
              type: "taxid",
              originalMerchantId: merchant.merchantId,
            },
          ]
        : []),
    ]),
  ];
  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    setData((prevData) =>
      prevData.map((item) =>
        item.label === "Funder"
          ? { ...item, value: contractTerms?.contractTerms?.funder?.id || null }
          : item
      )
    );
  }, [contractTerms?.contractTerms?.funder?.name]);

  useEffect(() => {
    loadSalesRepsForCurrentBroker(brokerId);
    setData((prevData) =>
      prevData.map((item) =>
        item.label === "ISO/Broker" ? { ...item, value: brokerId || null } : item
      )
    );
  }, [brokerId]);

  useEffect(() => {
    console.log("=== MERCHANT BUSINESS INFO CHANGED ===");
    console.log("merchantBusinessInfo:", merchantBusinessInfo);
    console.log("Country from merchantBusinessInfo:", merchantBusinessInfo?.country);

    setFederalTaxId(merchantBusinessInfo?.federalTaxId || null);
    if (merchantBusinessInfo) {
      setData((prevData) =>
        prevData.map((item) => {
          if (item.label === "Business Name") {
            return { ...item, value: merchantBusinessInfo.merchantId || null };
          }
          if (item.label === "Federal Tax ID") {
            return { ...item, value: merchantBusinessInfo.federalTaxId };
          }
          if (item.label === "Country") {
            const country = merchantBusinessInfo.country || ""; // Default to empty
            console.log("Setting country to:", country);
            console.log("Previous selectedCountry:", selectedCountry);
            setSelectedCountry(country);
            return { ...item, value: country };
          }
          if (item.label === "State") {
            return {
              ...item,
              value:
                merchantBusinessInfo.state || merchantBusinessInfo?.physicalAddress?.state || "",
            };
          }
          return item;
        })
      );
    }
  }, [merchantBusinessInfo]);

  useEffect(() => {
    if (!dealApplicationId) return;
    const fetchDealApplication = async () => {
      try {
        const responseData = await get(`/getDealApplication/${dealApplicationId}`);
        setData((prevData) =>
          prevData.map((item) => {
            if (item.label === "Amount Requested") {
              return { ...item, value: responseData.requestedAmount };
            }
            return item;
          })
        );
      } catch (error) {
        console.error("Error fetching amount requested:", error);
      }
    };
    fetchDealApplication();
  }, [dealApplicationId]);

  useEffect(() => {
    const dataMerch = contractData?.contractTerms?.dataMerch;

    if (Array.isArray(dataMerch) && dataMerch.length > 0) {
      try {
        const merchants = dataMerch
          .filter((item) => item)
          .map((item) => {
            const notesArray = Array.isArray(item?.merchant?.notes)
              ? item.merchant.notes
                  .filter((note) => note?.note)
                  .map((note) => ({ note: { ...note.note } }))
              : [];

            return {
              merchant: {
                ...item.merchant,
                notes: notesArray,
              },
            };
          });

        const firstNotes = Array.isArray(dataMerch[0]?.merchant?.notes)
          ? dataMerch[0].merchant.notes.filter((note) => note?.note?.category != null)
          : [];

        const categories = [...new Set(firstNotes.map((note) => note.note.category))];

        setDataMerch(merchants);
        setUniqueDataMerchCategory(categories);
        setDataMerchMessage("");
      } catch (error) {
        console.error("Error while processing dataMerch:", error);
      }
    } else {
      console.log("No notes found in contractData.");
      setDataMerch([]);
      setUniqueDataMerchCategory([]);
      setDataMerchMessage("No merchant notes found.");
    }
  }, [contractData]);

  const handleAmountRequestedChange = () => {
    const updatedValue = event.target.value;

    setData((prevData) =>
      prevData.map((item) =>
        item.label === "Amount Requested" ? { ...item, value: updatedValue } : item
      )
    );
  };

  const handleCheckDataMerchClick = () => {
    if (!dealApplicationId) {
      console.error("Required: dealApplicationId is missing.");
      return;
    }
    if (!merchantBusinessInfo) {
      console.error("Required: merchantBusinessInfo is missing.");
      return;
    }

    const merchantOrEin = merchantBusinessInfo.federalTaxId
      ? merchantBusinessInfo.federalTaxId
      : merchantBusinessInfo.merchantName;
    if (!merchantOrEin) {
      console.error("Required: Either federalTaxId or merchantName is missing.");
      return;
    }
    const payload = {
      dealApplicationId: dealApplicationId,
      merchantOrEin: merchantOrEin,
      refreshData: true,
    };

    post("dataMerch/merchant", payload)
      .then((response) => {
        console.log("DataMerch API response:", response);
        setDataMerch(response.data);

        if (!response.data || response.data.length === 0) {
          console.log("No data found, setting message:", response.message);
          setDataMerchMessage(response.message || "No data available");
          setUniqueDataMerchCategory([]);
        } else {
          const categories = [
            ...new Set(
              response.data
                .filter((item) => item?.merchant)
                .flatMap((item) => {
                  if (!Array.isArray(item.merchant.notes)) {
                    return [];
                  }
                  return item.merchant.notes
                    .filter((note) => note?.note)
                    .map((note) => note.note.category)
                    .filter((category) => category);
                })
            ),
          ];
          setUniqueDataMerchCategory(categories);
          setDataMerchMessage("");
        }
      })
      .catch((error) => {
        console.error("Error with DataMerch API request:", error);
        setDataMerch([]);
        setUniqueDataMerchCategory([]);
        setDataMerchMessage("Error fetching data. Please try again.");
      });
  };

  const handleOpenDetailsModal = (merchant) => {
    if (merchant) {
      setShowDetailsModal(true);
    } else {
      console.log("No merchant data available.");
    }
  };

  const handleCloseDetailsModal = () => {
    setShowDetailsModal(false);
  };

  const handleOpenNoteDetailsModal = () => {
    setShowDetailsModal(true);
  };

  const handleAmountRequestedBlur = () => {
    const requestedAmount = data.find((item) => item.label === "Amount Requested").value;
    const cleanedRequestedAmount = parseFloat(requestedAmount.toString().replace(/[^0-9.-]+/g, ""));
    if (cleanedRequestedAmount) {
      const payload = {
        requestedAmount: cleanedRequestedAmount,
        tenantId: Number(localStorage.getItem("tenantId")),
        partyId: merchantBusinessInfo?.merchantId,
        applicationId: dealApplicationId,
      };
      console.log("payload for amount", payload);
      post("/updateAmountRequested", payload)
        .then((response) => {
          console.log("Amount updated successfully", response);
        })
        .catch((error) => {
          console.error("Error updating amount", error);
        });
    }
  };

  const handleDropdownChange = async (event, label, reason) => {
    const updatedValue = event.target.value;

    if (label === "Business Name") {
      if (updatedValue === "Add New Merchant" || reason === "clear") {
        if (updatedValue === "Add New Merchant") {
          setIsAddingNewMerchant(true);
        }
        setNewBusinessName("");
        setFederalTaxId("");
        setSelectedCountry("US");
        setData((prevData) =>
          prevData.map((item) =>
            item.label === "Federal Tax ID" || item.label === "State" || item.label === "Country"
              ? { ...item, value: item.label === "Country" ? "US" : null }
              : item
          )
        );

        setData((prevData) =>
          prevData.map((item) => (item.label === "Business Name" ? { ...item, value: null } : item))
        );
        clearAllData();
        triggerClearData();
      } else {
        setIsAddingNewMerchant(false);
        const payload = {
          dealApplicationId: Number(dealApplicationId),
          merchantId: updatedValue,
        };

        try {
          const result = await post("application/changeMerchantById", payload);

          if (!result) {
            console.warn("No response received from server.");
            return;
          }
        } catch (error) {
          console.error("Error while changing merchant:", error);
          return;
        }

        const selectedMerchant = updatedValue
          ? merchantData?.find((merchant) => merchant?.merchantId === updatedValue)
          : null;

        if (selectedMerchant) {
          setNewMerchantId(selectedMerchant.merchantId);
          setFederalTaxId(selectedMerchant?.federalTaxId || "");
          fetchMerchantData(selectedMerchant.merchantId, true);

          setData((prevData) =>
            prevData.map((item) =>
              item.label === "Federal Tax ID"
                ? { ...item, value: selectedMerchant.federalTaxId }
                : item
            )
          );
        } else {
          setNewBusinessName("");
          setFederalTaxId("");
          setSelectedCountry("");
          setData((prevData) =>
            prevData.map((item) =>
              item.label === "Federal Tax ID" || item.label === "State" || item.label === "Country"
                ? { ...item, value: "" }
                : item
            )
          );
          triggerClearData();
        }
      }
    }

    if (label === "Country") {
      console.log("=== COUNTRY CHANGE DEBUG ===");
      console.log("Reason:", reason);
      console.log("Updated Value:", updatedValue);
      console.log("Previous Country:", selectedCountry);
      console.log("Merchant ID:", merchantBusinessInfo?.merchantId);
      console.log("Deal Application ID:", dealApplicationId);

      if (reason === "clear") {
        console.log("Clearing country field");
        setData((prevData) =>
          prevData.map((item) => (item.label === "Country" ? { ...item, value: "" } : item))
        );
        return;
      }
      const previousCountry = selectedCountry;

      const payload = {
        id: merchantBusinessInfo.merchantId,
        countryCode: updatedValue,
      };

      console.log("Checking if country can be changed...");
      console.log("canChangeState payload:", {
        dealApplicationId: dealApplicationId,
        countryCode: updatedValue,
        activeStep: 1,
      });

      post("canChangeState", {
        dealApplicationId: dealApplicationId,
        countryCode: updatedValue,
        activeStep: 1,
      })
        .then((responseData) => {
          console.log("canChangeState response:", responseData);

          if (responseData === false) {
            console.log("❌ Country change NOT allowed.");
          } else if (responseData === true) {
            console.log("✅ Country change allowed. Updating merchant country...");
            console.log("updateMerchantCountry payload:", payload);

            post("updateMerchantCountry", payload)
              .then((response) => {
                console.log("updateMerchantCountry response:", response);

                if (response.data === true) {
                  console.log("✅ Country updated successfully.");

                  setSelectedCountry(updatedValue);
                  setData((prevData) =>
                    prevData.map((item) => {
                      if (item.label === "Country") {
                        return { ...item, value: updatedValue };
                      }
                      if (item.label === "State") {
                        return { ...item, value: "" }; // Reset state when country changes
                      }
                      return item;
                    })
                  );
                  console.log("Fetching updated merchant data...");
                  fetchMerchantData(merchantBusinessInfo?.merchantId, false);
                } else {
                  console.log("⚠️ Update response data is not true:", response);
                }
              })
              .catch((error) => {
                console.error("❌ Error updating country:", error);
                setSelectedCountry(previousCountry);
                setData((prevData) =>
                  prevData.map((item) =>
                    item.label === "Country" ? { ...item, value: previousCountry } : item
                  )
                );
              });
          } else {
            console.log("⚠️ Unexpected canChangeState response:", responseData);
          }
        })
        .catch((error) => {
          console.error("❌ Error checking if country can be changed:", error);
          setSelectedCountry(previousCountry);
          setData((prevData) =>
            prevData.map((item) =>
              item.label === "Country" ? { ...item, value: previousCountry } : item
            )
          );
        });
      return;
    }

    if (label === "State") {
      if (reason === "clear") {
        setData((prevData) =>
          prevData.map((item) => (item.label === "State" ? { ...item, value: "" } : item))
        );
        return;
      }
      const previousState = merchantBusinessInfo.state;

      const payload = {
        merchantId: merchantBusinessInfo.merchantId,
        state: updatedValue,
        dealApplicationId: dealApplicationId,
        countryCode: selectedCountry || "US",
      };

      post("canChangeState", {
        dealApplicationId: dealApplicationId,
        state: updatedValue,
        activeStep: 1,
      })
        .then((responseData) => {
          if (responseData === false) {
            console.log("State change not allowed.");
          } else if (responseData === true) {
            post("updateMerchantState", payload)
              .then((response) => {
                if (response.result === true) {
                  console.log("State updated successfully.");

                  setData((prevData) =>
                    prevData.map((item) =>
                      item.label === label ? { ...item, value: updatedValue } : item
                    )
                  );
                  fetchMerchantData(merchantBusinessInfo?.merchantId, false);
                }
              })
              .catch((error) => {
                console.error("Error updating state:", error);
                setData((prevData) =>
                  prevData.map((item) =>
                    item.label === "State" ? { ...item, value: previousState } : item
                  )
                );
              });
          }
        })
        .catch((error) => {
          console.error("Error checking if state can be changed:", error);
          setData((prevData) =>
            prevData.map((item) =>
              item.label === "State" ? { ...item, value: previousState } : item
            )
          );
        });
    }

    if (label === "ISO Representative") {
      const selectedUser = userList.find((user) => user.id === updatedValue);
      if (selectedUser) {
        const payload = {
          applicationId: dealApplicationId,
          userId: selectedUser.id,
        };
        console.log("Payload for /setRepresentativeUser:", payload);
        post("setRepresentativeUser", payload)
          .then((responseData) => {
            console.log("setRepresentativeUser API response:", responseData);
          })
          .catch((err) => {
            console.error("Error in /setRepresentativeUser API call:", err);
          });
      }
    }

    if (label === "Funder") {
      if (reason === "clear") {
        setData((prevData) =>
          prevData.map((item) => (item.label === "Funder" ? { ...item, value: null } : item))
        );
        return;
      }
      const selectedFunder = funderList.find((funder) => funder.id === updatedValue);
      if (selectedFunder) {
        const updatedContractData = contractTerms;
        updatedContractData.contractTerms.funder = {
          id: selectedFunder?.id,
          name: selectedFunder?.name,
          defaultBrokerId: selectedFunder?.defaultBrokerId || null,
          defaultBrokerName: selectedFunder?.defaultBrokerName || null,
          defaultSyndicatorId: selectedFunder?.defaultSyndicatorId || null,
          defaultSyndicatorName: selectedFunder?.defaultSyndicatorName || null,
        };

        const payload = {
          ...updatedContractData,
          applicationId: dealApplicationId,
          tenantId: Number(localStorage.getItem("tenantId")),
        };

        try {
          await saveContractTerms(payload);
          console.log("payload for funder is", payload);

          const response = await post("saveContractTerms", payload);
          console.log("Funder updated successfully:", response);

          setData((prevData) =>
            prevData.map((item) =>
              item.label === "Funder" ? { ...item, value: selectedFunder?.id } : item
            )
          );

          const updatedContractTerms = await getContractTerms(dealApplicationId);
          console.log("Refreshed contract terms:", updatedContractTerms);
        } catch (error) {
          console.error("Error updating funder:", error);
          setData((prevData) =>
            prevData.map((item) =>
              item.label === "Funder"
                ? { ...item, value: contractTerms?.contractTerms?.funder?.id || null }
                : item
            )
          );
        }
      }
    }

    if (label === "ISO/Broker") {
      const selectedBroker = brokerParties.find((broker) => broker.id === updatedValue);
      if (selectedBroker) {
        const payload = {
          dealApplicationId: dealApplicationId,
          brokerId: selectedBroker.id,
        };

        post("setBroker", payload)
          .then(() => {
            setBrokerId(selectedBroker.id);
            setBrokerName(selectedBroker.name);
            setData((prevData) =>
              prevData.map((item) =>
                item.label === "ISO/Broker" ? { ...item, value: selectedBroker.id } : item
              )
            );
            fetchUsersRole();
          })
          .catch((err) => {
            console.error("Error in /setBroker API call:", err);
          });
        updateSalesReps(null, dealApplicationId);
        loadSalesRepsForCurrentBroker(selectedBroker.id);
      }
    }
  };

  const customFilterOptions = (options, { inputValue }) => {
    const filtered = options.filter((option) => {
      if (!option.label || typeof option.label !== "string") {
        return false;
      }

      const isMatch = option.label.toLowerCase().includes(inputValue.toLowerCase());
      return isMatch;
    });
    return filtered;
  };

  const handleFederalTaxIdChange = (event) => {
    let updatedValue = event.target.value;

    let formattedValue = updatedValue.replace(/[^\d\-]/g, "");
    if (formattedValue.length > 2 && formattedValue.charAt(2) !== "-") {
      formattedValue = formattedValue.slice(0, 2) + "-" + formattedValue.slice(2);
    }

    if (formattedValue.length > 10) {
      formattedValue = formattedValue.slice(0, 10);
    }

    if (formattedValue !== federalTaxId) {
      setFederalTaxId(formattedValue);
      console.log("federalTaxId updated:", formattedValue);

      setData((prevData) =>
        prevData.map((item) =>
          item.label === "Federal Tax ID" ? { ...item, value: formattedValue } : item
        )
      );
    }
  };

  const handleSaveFederalTaxId = () => {
    const merchantIdToUse = newMerchantId || merchantBusinessInfo.merchantId;

    if (!merchantIdToUse || !federalTaxId) {
      return;
    }

    const validationError = validateMerchantTaxId(federalTaxId);

    if (validationError) {
      setValidationError([validationError]);
      return;
    }

    const payload = {
      merchantId: merchantIdToUse,
      federalTaxId: federalTaxId,
    };

    post("updateMerchantEIN", payload)
      .then((response) => {
        if (response.result) {
          console.log("Federal Tax ID updated successfully.");
          updateMerchantBusinessInfo((prevState) => ({
            ...prevState,
            federalTaxId: federalTaxId,
          }));
        }
      })

      .catch((error) => {
        console.error("Error updating Federal Tax ID:", error);
      });
  };

  const validateMerchantTaxId = (taxId) => {
    const taxidPattern = /^[0-9]{2}[-][0-9]{7}$/;
    let error = "";

    if (!taxidPattern.test(taxId)) {
      error = "Invalid Tax ID format. Ex: xx-xxxxxxx";
    }

    if (!error) {
      const existingMerchant = merchantData.find(
        (merchant) =>
          merchant.federalTaxId === taxId && merchant.merchantId !== merchantBusinessInfo.merchantId
      );

      if (existingMerchant) {
        error = `Merchant with EIN ${taxId} already exists: ${existingMerchant.businessLegalName}`;
      }
    }

    return error;
  };

  const handleSaveNewMerchant = async () => {
    if (!newBusinessName) return;

    try {
      const newMerchantPayload = {
        businessLegalName: newBusinessName,
        merchantName: newBusinessName,
        tenantId: Number(localStorage.getItem("tenantId")),
        country_code: selectedCountry || "US",
      };

      const response = await post("merchant/updateOrCreateMerchantAndUsers", newMerchantPayload);
      if (response.result) {
        const newMerchantId = response.partyId;

        const setMerchantPayload = {
          dealApplicationId: dealApplicationId,
          merchantId: newMerchantId,
        };
        await post("setMerchant", setMerchantPayload);

        const requestBody = {
          partyId: newMerchantId,
          userId: Number(localStorage.getItem("logInUserId")),
          tenantId: Number(localStorage.getItem("tenantId")),
          applicationId: dealApplicationId,
        };
        await post("updateDealApplication", requestBody);

        const merchantId = newMerchantId;
        const responseData = await get(`fetchMerchantAndOwners/${merchantId}`);
        const updatedMerchantData = [...merchantData, responseData];
        setMerchantData(updatedMerchantData);
        updateMerchantAndOwners(responseData);
        setDbaInformationData(responseData.dba || []);
        setAffiliatedBusinessesData(responseData.affiliatedBusinesses || []);

        const selectedMerchant = newMerchantId
          ? updatedMerchantData?.find((merchant) => merchant?.merchantId === newMerchantId)
          : null;

        if (selectedMerchant) {
          setNewMerchantId(selectedMerchant?.merchantId);
          setFederalTaxId(selectedMerchant?.federalTaxId);
          updateMerchantBusinessInfo(selectedMerchant);

          setData((prevData) =>
            prevData.map((item) =>
              item.label === "Business Name"
                ? { ...item, value: selectedMerchant?.merchantId }
                : item
            )
          );
        }
      }
    } catch (error) {
      console.error("Error saving new merchant:", error);
    } finally {
      setIsAddingNewMerchant(false);
    }
  };

  if (merchantData.length === 0 || !dealApplicationId || userList.length === 0) {
    return null;
  }

  const onAddNewBroker = async (value: string): boolean => {
    if (!value) {
      setIsAddingNewBroker(false);
      return true;
    }

    const nameExists = brokerParties?.some(
      (broker: any) => broker?.name?.toLowerCase() === value.toLowerCase()
    );

    if (nameExists) {
      return false;
    }

    let broker = {
      businessLegalName: value,
      name: value,
      isBroker: true,
      tenantId: localStorage.getItem("tenantId"),
    };

    const response = await post("facilitator/createOrUpdateSyndicator", broker);
    if (response.id) {
      const payload = {
        dealApplicationId: dealApplicationId,
        brokerId: response.id,
      };
      await post("setBroker", payload);
      await updateSalesReps(null, dealApplicationId);
      setIsAddingNewBroker(false);
      fetchBrokerData(dealApplicationId);
    }

    return true;
  };

  const onAddNewFunder = async (value: string): boolean => {
    if (!value) {
      setIsAddingNewFunder(false);
      return true;
    }

    const nameExists = funderList?.some(
      (funder: any) => funder?.name?.toLowerCase() === value.toLowerCase()
    );

    if (nameExists) {
      return false;
    }

    let funder = {
      businessLegalName: value,
      name: value,
      isFunder: true,
      tenantId: localStorage.getItem("tenantId"),
    };

    const response = await post("facilitator/createOrUpdateSyndicator", funder);
    if (response.id) {
      const funders = await fetchFunderList();

      const selectedFunder = funders.find((funder) => funder.id === response.id);
      if (selectedFunder) {
        const updatedContractData = contractTerms;
        updatedContractData.contractTerms.funder = {
          id: selectedFunder?.id,
          name: selectedFunder?.name,
          defaultBrokerId: selectedFunder?.defaultBrokerId || null,
          defaultBrokerName: selectedFunder?.defaultBrokerName || null,
          defaultSyndicatorId: selectedFunder?.defaultSyndicatorId || null,
          defaultSyndicatorName: selectedFunder?.defaultSyndicatorName || null,
        };

        const payload = {
          ...updatedContractData,
          applicationId: dealApplicationId,
          tenantId: Number(localStorage.getItem("tenantId")),
        };

        try {
          await saveContractTerms(payload);
          console.log("payload for funder is", payload);

          const response = await post("saveContractTerms", payload);
          console.log("Funder updated successfully:", response);

          setData((prevData) =>
            prevData.map((item) =>
              item.label === "Funder" ? { ...item, value: selectedFunder?.id } : item
            )
          );

          const updatedContractTerms = await getContractTerms(dealApplicationId);
        } catch (error) {
          console.error("Error updating funder:", error);
          setData((prevData) =>
            prevData.map((item) =>
              item.label === "Funder"
                ? { ...item, value: contractTerms?.contractTerms?.funder?.id || null }
                : item
            )
          );
        }
      }
    }
    setIsAddingNewFunder(false);
    return true;
  };

  const renderDataMerchCategories = () => {
    if (dataMerchMessage) {
      return (
        <Box
          sx={{
            fontSize: "15px",
            color: "black",
            fontStyle: "italic",
            display: "inline-flex",
            marginRight: "1px",
            alignItems: "center",
            verticalAlign: "middle",
          }}
        >
          No DataMerch available
        </Box>
      );
    }

    if (!Array.isArray(uniqueDataMerchCategory) || uniqueDataMerchCategory.length === 0) {
      return null;
    }

    return (
      <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
        {uniqueDataMerchCategory.length > 0 ? (
          <>
            {uniqueDataMerchCategory.map((category, index) => (
              <Box
                key={index}
                sx={{
                  border: "3px solid white",
                  height: "30px",
                  backgroundColor: dataMerchColorMapping[category] || "#000",
                  color: "white !important",
                  display: "inline-flex",
                  borderRadius: "25px",
                  padding: "6px 12px",
                  alignItems: "center",
                  verticalAlign: "middle",
                  cursor: "pointer",
                  fontSize: "17px",
                }}
                onClick={() => setShowDataMerchModal(true)}
              >
                {category}
              </Box>
            ))}
            <Box
              sx={{
                border: "3px solid white",
                height: "24px",
                color: "blue",
                display: "inline-flex",
                marginRight: "1px",
                borderRadius: "12px",
                alignItems: "center",
                verticalAlign: "middle",
                cursor: "pointer",
                fontSize: "17px",
              }}
              onClick={() => setShowDataMerchModal(true)}
            >
              Click for details
            </Box>
          </>
        ) : null}
      </Box>
    );
  };

  const validationModal = (
    <Modal
      open={validationError}
      onClose={() => {
        setValidationError(null);
      }}
      aria-labelledby="undo-deal-modal"
      aria-describedby="undo-deal-description"
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
          maxWidth: 600,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <MDBox>
          <MDBox display={"flex"} flexDirection={"column"}>
            {validationError?.map((error, key) => (
              <MDTypography key={key}>
                <span style={{ color: "red" }}>** </span>
                {error}
              </MDTypography>
            ))}
          </MDBox>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <MDButton
              variant="contained"
              color="primary"
              onClick={() => {
                setValidationError(null);
              }}
            >
              Ok
            </MDButton>
          </Box>
        </MDBox>
      </MDBox>
    </Modal>
  );

  const StyleChip = styled(Chip)(() => ({
    backgroundColor: "#2F929F",

    "&.MuiChip-root": {
      backgroundColor: "#73BEC6",
      color: "#fff",
    },
  }));

  const renderDataMerchModal = () => {
    const allMerchants = [...(Array.isArray(dataMerch) ? dataMerch : [])];

    if (
      Array.isArray(contractData?.contractTerms?.dataMerch) &&
      contractData.contractTerms.dataMerch.length > 0
    ) {
      const contractMerchants = contractData.contractTerms.dataMerch
        .filter((dataMerchItem) => dataMerchItem?.merchant)
        .map((dataMerchItem) => ({
          merchant: {
            ...dataMerchItem.merchant,
            notes: Array.isArray(dataMerchItem.merchant.notes)
              ? dataMerchItem.merchant.notes
                  .filter((note) => note?.note)
                  .map((note) => ({ note: { ...note.note } }))
              : [],
          },
        }));

      allMerchants.push(...contractMerchants);
    }

    return (
      <Modal open={showDataMerchModal} onClose={() => setShowDataMerchModal(false)}>
        <Box
          sx={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            margin: "auto",
            marginTop: "10%",
            width: "60%",
            border: "2px solid #999",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <Typography variant="h5" sx={{ textAlign: "center", marginBottom: "20px" }}>
            Merchants
          </Typography>
          {allMerchants.length > 0 ? (
            <Table>
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <TableCell
                    sx={{ fontWeight: "bold", borderBottom: "1px solid #ddd", width: "20%" }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", borderBottom: "1px solid #ddd", width: "15%" }}
                  >
                    EIN/BN
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", borderBottom: "1px solid #ddd", width: "20%" }}
                  >
                    Added By
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", borderBottom: "1px solid #ddd", width: "25%" }}
                  >
                    Added on
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", borderBottom: "1px solid #ddd", width: "20%" }}
                  >
                    Latest Note Category
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allMerchants.map((item, index) => (
                  <TableRow
                    key={index}
                    onClick={() => handleOpenDetailsModal(item.merchant)}
                    sx={{ "&:hover": { backgroundColor: "#f5f5f5", cursor: "pointer" } }}
                  >
                    <TableCell sx={{ borderBottom: "1px solid #ddd", width: "20%" }}>
                      {item.merchant.legal_name || "N/A"}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd", width: "15%" }}>
                      {item.merchant.fein || "N/A"}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd", width: "20%" }}>
                      {item.merchant.notes[0]?.note.added_by || "N/A"}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd", width: "25%" }}>
                      {item.merchant.notes[0]?.note.created_at || "N/A"}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd", width: "20%" }}>
                      <Box
                        sx={{
                          backgroundColor:
                            dataMerchColorMapping[item.merchant.notes[0]?.note.category] || "#000",
                          color: "white !important",
                          borderRadius: "16px",
                          marginLeft: "20px",
                          padding: "5px 10px",
                          display: "inline-flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenNoteDetailsModal(item.merchant.notes[0]?.note);
                        }}
                      >
                        {item.merchant.notes[0]?.note.category || "N/A"}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : null}
        </Box>
      </Modal>
    );
  };

  const renderDetailsModal = () => (
    <Modal open={showDetailsModal} onClose={handleCloseDetailsModal}>
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "10px",
          margin: "auto",
          marginTop: "10%",
          width: "40%",
          maxHeight: "70vh",
          overflowY: "auto",
          border: "2px solid #999",
        }}
      >
        {dataMerch.length > 0 && dataMerch[0].merchant ? (
          <>
            <Typography
              variant="h5"
              sx={{
                marginBottom: "20px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "10px",
              }}
            >
              {dataMerch[0]?.merchant.legal_name}
            </Typography>
            <Typography sx={{ fontSize: "18px" }}>
              <strong>EIN/BN:</strong> {dataMerch[0]?.merchant.fein}
            </Typography>
            <Typography sx={{ fontSize: "18px" }}>
              <strong>City, State:</strong> {dataMerch[0]?.merchant.city},{" "}
              {dataMerch[0].merchant.state}
            </Typography>
            <Typography sx={{ fontSize: "18px" }}>
              <strong>Doing Business As:</strong> {dataMerch[0]?.merchant.dba}
            </Typography>
            <Typography sx={{ fontSize: "18px" }}>
              <strong>Business Phone:</strong> {dataMerch[0]?.merchant.business_phone || "N/A"}
            </Typography>

            <Box sx={{ marginTop: "20px" }}>
              <Table>
                <TableBody>
                  {dataMerch[0]?.merchant.notes.map((note, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ width: "30%", verticalAlign: "top", padding: "8px 0" }}>
                        <Box
                          sx={{
                            backgroundColor: dataMerchColorMapping[note.note.category] || "#000",
                            color: "white !important",
                            borderRadius: "16px",
                            padding: "5px 10px",
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          {note.note.category}
                        </Box>
                      </TableCell>

                      <TableCell sx={{ verticalAlign: "top", padding: "8px 0" }}>
                        <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
                          {note.note.created_at} by {note.note.added_by}
                        </Typography>
                        <Typography sx={{ color: "#333", fontSize: "16px", marginTop: "5px" }}>
                          {note.note.note}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </>
        ) : (
          <Typography>No merchant data available.</Typography>
        )}
      </Box>
    </Modal>
  );

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
        marginBottom: "12px",
        border: "1px solid #f0f0f0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "5px",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Initial Information
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isExpanded && (
            <Box sx={{ display: "flex", alignItems: "center", gap: "1px", marginRight: "30px" }}>
              {renderDataMerchCategories()}
            </Box>
          )}
          {isExpanded && (
            <MDButton variant="gradient" color="primary" onClick={handleCheckDataMerchClick}>
              Check DataMerch
            </MDButton>
          )}
          <IconButton onClick={toggleExpand} sx={{ marginLeft: "8px" }}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>

      {isExpanded && (
        <form>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              alignItems: "center",
            }}
          >
            {data.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth:
                    item.label === "Business Name"
                      ? "250px"
                      : item.label === "State" ||
                        item.label === "Federal Tax ID" ||
                        item.label === "Country"
                      ? "80px"
                      : "100px",
                  maxWidth:
                    item.label === "State" || item.label === "Country"
                      ? "190px"
                      : item.label === "Federal Tax ID"
                      ? "105px"
                      : item.label === "Funder" ||
                        item.label === "ISO/Broker" ||
                        item.label === "Sales Representative"
                      ? "200px"
                      : "150px",
                  flex: "1 1 calc(11% - 20px)",
                  padding: "2px",
                  paddingLeft: "2px",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.875rem",
                    color: "#6b7280",
                    marginBottom: "5px",
                  }}
                >
                  {item.label === "State" ? getStateProvinceLabel(selectedCountry) : item.label}
                </Typography>

                {item.label === "Sales Representative" ? (
                  <Autocomplete
                    fullWidth
                    multiple
                    variant="standard"
                    options={salesRepOptions}
                    getOptionLabel={(option) => option.label}
                    clearIcon={null}
                    popupIcon={<ExpandMoreIcon />}
                    value={salesRepOptions?.filter((opt) => assignedRepIds?.includes(opt.value))}
                    onChange={(_event, newSelectedOptions) => {
                      updateSalesReps(newSelectedOptions, dealApplicationId);
                    }}
                    renderTags={(selected, getTagProps) =>
                      selected?.map((option, index) => (
                        <StyleChip
                          label={option.label}
                          {...getTagProps({ index })}
                          key={option.value}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            flexWrap: "wrap",
                            alignItems: "center",
                            minHeight: "28px",
                            paddingBottom: "2px",
                          },
                        }}
                      />
                    )}
                    sx={{
                      "& .MuiAutocomplete-inputRoot": {
                        padding: "2px 4px !important",
                        alignItems: "center",
                      },
                      "& .MuiChip-root": {
                        margin: "2px",
                      },
                    }}
                  />
                ) : item.label === "Amount Requested" ? (
                  <NumericFormat
                    variant="standard"
                    value={item?.value}
                    onValueChange={({ value }: any) => {
                      const numericAmount = parseFloat(value.replace(/[^0-9.-]+/g, ""));
                      handleAmountRequestedChange(numericAmount);
                    }}
                    onBlur={handleAmountRequestedBlur}
                    thousandSeparator
                    prefix="$"
                    decimalScale={2}
                    fixedDecimalScale
                    allowNegative={false}
                    customInput={MDInput}
                    inputProps={{ style: { fontSize: 14 } }}
                  />
                ) : item.label === "ISO/Broker" ? (
                  <MDSelect
                    disableClearable={true}
                    isAddingNew={isAddingNewBroker}
                    sx={{ mt: -2 }}
                    value={
                      brokerParties.find((b) => b.id === item.value)
                        ? {
                            label: brokerParties.find((b) => b.id === item.value).name,
                            value: item.value,
                          }
                        : null
                    }
                    options={
                      brokerParties.length > 0
                        ? brokerParties.map((broker) => ({
                            label: broker.name,
                            value: broker.id,
                          }))
                        : []
                    }
                    onChange={(newValue) => {
                      if (!newValue) return;

                      if ((newValue as any).isAddNew) {
                        setIsAddingNewBroker(true);
                        return;
                      }

                      handleDropdownChange(
                        { target: { value: newValue?.value } },
                        item?.label,
                        null
                      );
                    }}
                    addNewOption
                    onAddNewSubmit={(value: any) => {
                      if (onAddNewBroker) {
                        return onAddNewBroker(value);
                      } else {
                        return false;
                      }
                    }}
                    getOptionLabel={(option) => option.label}
                    enableValueEqualityCheck={true}
                  />
                ) : item.label === "Funder" ? (
                  <MDSelect
                    disableClearable={true}
                    isAddingNew={isAddingNewFunder}
                    sx={{ mt: -2 }}
                    value={
                      funderList.find((f) => f.id === item.value)
                        ? {
                            label: funderList.find((f) => f.id === item.value).name,
                            value: item.value,
                          }
                        : null
                    }
                    options={
                      funderList.length > 0
                        ? funderList.map((funder) => ({
                            label: funder.name,
                            value: funder.id,
                          }))
                        : []
                    }
                    onChange={(newValue) => {
                      if (!newValue) return;

                      if ((newValue as any).isAddNew) {
                        setIsAddingNewFunder(true);
                        return;
                      }

                      handleDropdownChange(
                        { target: { value: newValue?.value } },
                        item?.label,
                        null
                      );
                    }}
                    addNewOption
                    onAddNewSubmit={(value: any) => {
                      if (onAddNewFunder) {
                        return onAddNewFunder(value);
                      } else {
                        return false;
                      }
                    }}
                    getOptionLabel={(option) => option.label}
                    enableValueEqualityCheck={true}
                  />
                ) : item.label === "Federal Tax ID" ? (
                  <TextField
                    fullWidth
                    value={federalTaxId}
                    disabled={
                      item.label === "Federal Tax ID" &&
                      (!merchantBusinessInfo || !merchantBusinessInfo.merchantId)
                    }
                    onChange={handleFederalTaxIdChange}
                    onBlur={handleSaveFederalTaxId}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        e.target.blur();
                      }
                    }}
                    size="small"
                    variant="standard"
                    className="underline-input"
                  />
                ) : item.label === "Business Name" && isAddingNewMerchant ? (
                  <TextField
                    fullWidth
                    value={newBusinessName}
                    onChange={(e) => setNewBusinessName(e.target.value)}
                    onBlur={handleSaveNewMerchant}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        e.target.blur();
                      }
                    }}
                    size="small"
                    variant="standard"
                    className="underline-input"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onMouseDown={(event) => {
                              event.preventDefault();
                              setNewBusinessName("");
                              setIsAddingNewMerchant(false);
                              setData((prevData) =>
                                prevData.map((item) =>
                                  item.label === "Business Name" ? { ...item, value: null } : item
                                )
                              );
                            }}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                ) : item.isDropdown ? (
                  <Autocomplete
                    fullWidth
                    variant="standard"
                    filterOptions={customFilterOptions}
                    disabled={
                      (item.label === "State" || item.label === "Country") &&
                      (!merchantBusinessInfo || !merchantBusinessInfo.merchantId)
                    }
                    value={
                      item.label === "Business Name"
                        ? merchantDropdownOptions.find((option) => {
                            if (item.value === "Add New Merchant") {
                              return option.value === "Add New Merchant";
                            }
                            if (option.type === "merchant" && option.value === item.value) {
                              return true;
                            }
                            if (
                              option.type === "taxid" &&
                              option.originalMerchantId === item.value
                            ) {
                              return true;
                            }
                            return false;
                          }) || null
                        : item.label === "Country"
                        ? countries.find((c) => c.value === item.value) || null
                        : item.label === "State"
                        ? getStatesProvinces(selectedCountry).find((s) => s.label === item.value) ||
                          null
                        : item.label === "Funder"
                        ? funderList.find((f) => f.id === item.value)
                          ? {
                              label: funderList.find((f) => f.id === item.value).name,
                              value: item.value,
                            }
                          : null
                        : item.label === "ISO/Broker"
                        ? brokerParties.find((b) => b.id === item.value)
                          ? {
                              label: brokerParties.find((b) => b.id === item.value).name,
                              value: item.value,
                            }
                          : null
                        : null
                    }
                    clearIcon={null}
                    onChange={(_event, newValue, reason) => {
                      if (newValue?.type === "taxid") {
                        handleDropdownChange(
                          { target: { value: newValue.originalMerchantId } },
                          item?.label,
                          reason
                        );
                      } else {
                        handleDropdownChange(
                          { target: { value: newValue?.value } },
                          item?.label,
                          reason
                        );
                      }
                    }}
                    size="medium"
                    open={openDropdown === item?.label}
                    onOpen={() => {
                      setOpenDropdown(item?.label);
                      if (listboxRef.current && item.label === "Business Name") {
                        listboxRef.current.scrollTop = 0;
                      }
                    }}
                    onClose={() => setOpenDropdown(null)}
                    popupIcon={
                      openDropdown === item?.label ? <ExpandLessIcon /> : <ExpandMoreIcon />
                    }
                    options={
                      item?.label === "Business Name"
                        ? merchantDropdownOptions
                        : item?.label === "Country"
                        ? countries.map((country) => ({
                            label: country.label,
                            value: country.value,
                          }))
                        : item?.label === "State"
                        ? getStatesProvinces(selectedCountry).map((state) => ({
                            label: state.label,
                            value: state.label,
                          }))
                        : item?.label === "Funder" && funderList.length > 0
                        ? funderList.map((funder) => ({
                            label: funder.name,
                            value: funder.id,
                          }))
                        : item?.label === "ISO/Broker" && brokerParties.length > 0
                        ? brokerParties.map((broker) => ({
                            label: broker.name,
                            value: broker.id,
                          }))
                        : []
                    }
                    getOptionLabel={(option) => option.label || ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          color: option.label === "Add New Merchant" ? "#3B82F6" : "#111827",
                          fontWeight: option.label === "Add New Merchant" ? 500 : 400,
                          padding: "8px 12px",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {option.label === "Add New Merchant" && (
                          <PersonAdd fontSize="small" style={{ color: "#3B82F6" }} />
                        )}
                        {option.label}
                      </li>
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: "400px",
                        overflowY: "auto",
                        padding: "4px 0",
                        scrollbarWidth: "thin",
                      },
                      ...(item?.label === "Business Name" ? { ref: listboxRef } : {}),
                    }}
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        color: "#6b7280",
                        right: "10px",
                      },
                      "& .MuiAutocomplete-listbox": {
                        borderRadius: "8px",
                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                      },
                      "& .MuiAutocomplete-listbox::-webkit-scrollbar": {
                        width: "2px",
                      },
                      "& .MuiAutocomplete-listbox::-webkit-scrollbar-thumb": {
                        backgroundColor: "#cbd5e1",
                        borderRadius: "2px",
                      },
                      "& .MuiAutocomplete-listbox::-webkit-scrollbar-track": {
                        backgroundColor: "transparent",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder={"Select.."}
                        InputLabelProps={{ shrink: false }}
                        className="underline-input"
                      />
                    )}
                    noOptionsText="No options available"
                  />
                ) : (
                  <TextField
                    fullWidth
                    value={item.value}
                    size="small"
                    variant="standard"
                    className="underline-input"
                  />
                )}
              </Box>
            ))}
          </Box>
        </form>
      )}

      {renderDataMerchModal()}
      {renderDetailsModal()}
      {
        <MDSnackbar
          open={snackBarData.open}
          content={snackBarData.content}
          title={snackBarData.title}
          color={snackBarData.color}
        ></MDSnackbar>
      }
      {validationError && validationError?.length > 0 && validationModal}
    </Box>
  );
};

export default InitialInformation;
